import { render, staticRenderFns } from "./preRegisterWFL.vue?vue&type=template&id=626e2146&scoped=true"
import script from "./preRegisterWFL.vue?vue&type=script&lang=js"
export * from "./preRegisterWFL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626e2146",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/python/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('626e2146')) {
      api.createRecord('626e2146', component.options)
    } else {
      api.reload('626e2146', component.options)
    }
    module.hot.accept("./preRegisterWFL.vue?vue&type=template&id=626e2146&scoped=true", function () {
      api.rerender('626e2146', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/preRegisterWFL.vue"
export default component.exports